import { ValidModule } from './valid/valid.module';
import { ErrorModule } from './error/error.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExternalComponent } from './external.component';
import { CiudadanoModule } from './ciudadano/ciudadano.module';
import { EmpresaModule } from './empresa/empresa.module';
import { ProveedorModule } from './proveedor/proveedor.module';
import { ExternalRoutingModule } from './external-routing.module';
import { AccesoExternalService } from './shared/acceso/acceso-external.service';
import { HomeExternalService } from './shared/home/home-external.service';

@NgModule({
  declarations: [
    ExternalComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ExternalRoutingModule,
    CiudadanoModule,
    EmpresaModule,
    ProveedorModule,
    ErrorModule,
    ValidModule
  ],
  providers: [AccesoExternalService, HomeExternalService]
})
export class ExternalModule { }
